<div class="header-chat-name">
  <h4>{{ getHeader() }}</h4>
  @if (recordCalenderIdSelectData.length) {
    <app-telegram-select-record-calendar-id
      [recordCalendarId]="recordCalendarId"
      [recordCalenderIdSelectData]="recordCalenderIdSelectData"
      [selectedChat]="selectedChat"
      (attachRecordCalendarId)="attachRecordCalendarId($event)"
    />
  }
</div>

@if (selectedChat) {
  <div class="chat-window">
    <div
      #chatContainer
      class="chat-window-container"
    >
      @if (telegramGroupedMessagesService.dates().length) {
        @for (date of telegramGroupedMessagesService.dates(); track $index) {
          <div class="message-group">
            @if (hasMessagesForDate(date, recordCalendarId)) {
              <div class="date-header">
                {{ date }}
              </div>
              @for (msg of telegramGroupedMessagesService.groupedMessages()[date]; track $index) {
                @if (recordCalendarId) {
                  @if (recordCalendarId === msg.recordCalendarId) {
                    <app-telegram-message-card
                      [message]="msg"
                      [selectedChat]="selectedChat"
                    />
                  }
                } @else {
                  <app-telegram-message-card
                    [message]="msg"
                    [selectedChat]="selectedChat"
                    [recordCalendarId]="recordCalendarId"
                  />
                }
              }
            }
          </div>
        }
      }

      @if (telegramChatWindowService.needUploadFileComponent) {
        <app-telegram-chat-upload-file/>
      }
    </div>
    <app-telegram-send-message
      [selectedChat]="selectedChat"
      (sendMessage)="handelSendMessage($event)"
    />
  </div>
}
